import { render, staticRenderFns } from "./PeixunDia.vue?vue&type=template&id=7a23cdfb&scoped=true&"
import script from "./PeixunDia.vue?vue&type=script&lang=js&"
export * from "./PeixunDia.vue?vue&type=script&lang=js&"
import style0 from "./PeixunDia.vue?vue&type=style&index=0&id=7a23cdfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a23cdfb",
  null
  
)

export default component.exports